import ApiService from "./APIService";

const refreshToken = async () => {
  let user = JSON.parse(localStorage.getItem("user"));

  if (typeof user === "string") {
    user = JSON.parse(user);
  }

  const refreshToken = user?.refresh_token;

  if (refreshToken) {
    const url = "token/fresh";

    try {
      const response = await ApiService.postLogin(url, { refresh_token: refreshToken });

      if (response.status === 200) {
        localStorage.setItem("user", JSON.stringify(JSON.stringify(response.data)));
        window.location.reload();
      }
    } catch (error) {
      console.error("Refresh token error", error.response?.data || error.message);
      localStorage.clear();
      window.location.reload();
    }
  } else {
    localStorage.clear();
    window.location.reload();
  }
};

export default { refreshToken };
